import { z } from "zod";

// Shared types for explore lump functionality
// This file exists to avoid circular dependencies between explore/types.ts and exploreLumpUtils.ts

export const ExploreLumpWindowFunctionLiteral = z.enum([
  "row_number",
  "rank",
  "dense_rank",
  "percent_rank",
  "cume_dist",
  "ntile",
  "lag",
  "lead",
]);
export type ExploreLumpWindowFunction = z.infer<
  typeof ExploreLumpWindowFunctionLiteral
>;

export const ExploreLumpOrderDirectionLiteral = z.enum(["asc", "desc"]);
export type ExploreLumpOrderDirection = z.infer<
  typeof ExploreLumpOrderDirectionLiteral
>;

export const ExploreRankPredicateOpLiteral = z.enum([
  "GT",
  "GTE",
  "EQ",
  "LTE",
  "LT",
]);
export type ExploreRankPredicateOp = z.infer<
  typeof ExploreRankPredicateOpLiteral
>;

export const ExploreRankPredicate = z.object({
  op: ExploreRankPredicateOpLiteral,
  arg: z.number(),
});
export type ExploreRankPredicate = z.infer<typeof ExploreRankPredicate>;
